import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import './facebook-button-help.scss';

applyTranslations(require('./facebook-button-help.i18n.json'));

const MSG_KEY = 'facebook_button_help';

const FacebookButtonHelp = (): JSX.Element => {
  const getLink = (
    key: 'support' | 'help'
  ): JSX.Element => {
    let attributes = {};
    let href = '';

    if (key === 'support') {
      href += 'mailto:';
    }

    if (key === 'help') {
      attributes = {
        target: '_blank',
        rel: 'noopener noreferrer'
      };
    }

    return (
      <a
        href={`${href}${__t(`${MSG_KEY}.links.${key}_url`)}`}
        {...attributes}
      >
        {__t(`${MSG_KEY}.links.${key}_text`)}
      </a>
    );
  };

  const supportLink = getLink('support');
  const helpLink = getLink('help');

  const text = sanitizeGenericHtml(
    __t(`${MSG_KEY}.text`, {
      supportLink: ReactDOMServer.renderToString(supportLink),
      helpLink: ReactDOMServer.renderToString(helpLink)
    })
  );

  return (
    <div className="facebook-button-help">
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

export default FacebookButtonHelp;
